import styled, { css } from 'styled-components';

import { TextButton, Typography } from '@speeki/global-ui-components';

import { maxWidth } from '@utils/helpers';

export const NotificationsListWrapper = styled.div<{ autoHeight?: boolean }>(
    ({ autoHeight }) => css`
        display: flex;
        flex-direction: column;
        height: ${autoHeight ? 'auto' : '416px'};

        ${maxWidth('md')} {
            height: 100%;
        }
    `,
);

export const NotificationsHeader = styled.div`
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 0 24px;

    ${maxWidth('xs')} {
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const MarkAsReadButton = styled(TextButton)`
    line-height: 24px;
    padding: 0;
`;

export const NotificationsWrapper = styled.div`
    overflow-y: auto;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const NotificationListItem = styled.div(
    ({ theme: { palette } }) => css`
        border-bottom: 1px solid ${palette.neutral.dividers};
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: 2px;
        padding: 16px 0;

        ${maxWidth('md')} {
            padding: 12px 0;
        }

        &:first-child {
            padding-top: 0;
        }

        &:last-child {
            border: none;
        }
    `,
);

export const ListItemHeader = styled.div`
    display: flex;
    gap: 24px;
    justify-content: space-between;

    ${maxWidth('md')} {
        flex-direction: column;
        gap: 2px;
    }
`;

export const ListItemTitle = styled(Typography.TextBody_16_24)<{
    unread?: boolean;
}>(
    ({ theme: { fontWeight, palette, radius }, unread }) => css`
        position: relative;

        ${unread &&
        css`
            font-weight: ${fontWeight.bold};

            &:before {
                background: ${palette.tertiary.default};
                border-radius: ${radius[50]}px;
                border: 1px solid ${palette.neutral.white};
                content: '';
                height: 8px;
                left: -16px;
                position: absolute;
                top: 6px;
                width: 8px;
            }
        `}
    `,
);

export const ListItemDate = styled(Typography.TextBody_12_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        padding-top: 2px;
        white-space: nowrap;
    `,
);

export const ListItemDescription = styled(Typography.TextH6_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.secondary};
    `,
);

export const InfiniteScrollWrapper = styled.div`
    margin-top: 16px;
`;

export const EmptyResultsWrapper = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 0 74px;
    text-align: center;
    flex: 1;
`;

export const EmptyResultText = styled(Typography.TextBody_16_28)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
    `,
);

export const SkeletonWrapper = styled.div`
    margin-bottom: 24px;
`;

export const SkeletonOptionWrapper = styled.div`
    display: grid;
    grid-template-columns: 80% 15%;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 100%;
`;

export const MobileSkeletonHeader = styled.div`
    margin-bottom: 8px;
`;
